import { MessageType } from '@components/chat/types'
import { Conversation } from '@features/conversation/components/Conversation'
import { useNavigate } from '@tanstack/react-router'
import { useState } from 'react'

export const HomePage = () => {
  const [messages, setMessages] = useState<Array<MessageType>>([])
  const [chatId, setChatId] = useState<string | undefined>()
  const navigate = useNavigate()

  return (
    <Conversation
      chatId={chatId}
      setChatId={(conversationId) => {
        setChatId(conversationId)
        console.log('Navigating to conversation ID:', conversationId)
        navigate({
          to: '/conversation/' + conversationId,
          reloadDocument: false,
        })
      }}
      messages={messages}
      setMessages={setMessages}
    />
  )
}
